import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-increase-traffic',
  templateUrl: './service-increase-traffic.component.html',
  styleUrls: ['./service-increase-traffic.component.css']
})
export class ServiceIncreaseTrafficComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
